module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-maedori3-9e254055419e5125fa57bf26892976e4.jpg";